"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventStatus = exports.EventStatusFilter = void 0;
var EventStatusFilter;
(function (EventStatusFilter) {
    EventStatusFilter["ACTIVE"] = "ACTIVE";
    EventStatusFilter["CLOSED"] = "CLOSED";
    EventStatusFilter["ALL"] = "ALL";
})(EventStatusFilter = exports.EventStatusFilter || (exports.EventStatusFilter = {}));
var EventStatus;
(function (EventStatus) {
    EventStatus["ACTIVE"] = "ACTIVE";
    EventStatus["CLOSED"] = "CLOSED";
    EventStatus["ALL"] = "ALL";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
//# sourceMappingURL=eventStatusFilter.js.map